import { moveToFulfilled, moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ResetGroupCreationStatusAction } from '../../domains/groupCreation/actions.types';
import { GroupCreateAction } from '../../domains/groups/actions.types';

import { GroupCreation } from './types';

export type GroupCreationAction = GroupCreateAction | ResetGroupCreationStatusAction;

const initialState: GroupCreation = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupCreation, GroupCreationAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'GROUP.CREATE_REJECTED':
      return moveToRejected(state, [action.payload.groupCreationId], action.payload.error);
    case 'GROUP.CREATE_PENDING':
      return moveToPending(state, [action.payload.groupCreationId]);
    case 'GROUP.CREATE_FULFILLED':
      return moveToFulfilled(state, { [action.payload.groupCreationId]: action.payload });
    case 'GROUP_CREATE.RESET_STATUS':
      return remove(state, [action.payload.groupCreationId]);
    default:
      return state;
  }
};

export default reducer;
